import MessageApiUtils from '../utils/api/message';

export const FETCH_MESSAGES_SENT = 'FETCH_MESSAGES_SENT';
export const FETCH_MESSAGES_SUCCEEDED = 'FETCH_MESSAGES_SUCCEEDED';
export const FETCH_MESSAGES_FAILED = 'FETCH_MESSAGES_FAILED';
export const LOAD_MORE_MESSAGES_SENT = 'LOAD_MORE_MESSAGES_SENT';
export const LOAD_MORE_MESSAGES_SUCCEEDED = 'LOAD_MORE_MESSAGES_SUCCEEDED';
export const LOAD_MORE_MESSAGES_FAILED = 'LOAD_MORE_MESSAGES_FAILED';
export const SEND_MESSAGE_SENT = 'SEND_MESSAGE_SENT';
export const SEND_MESSAGE_SUCCEEDED = 'SEND_MESSAGE_SUCCEEDED';
export const SEND_MESSAGE_FAILED = 'SEND_MESSAGE_FAILED';
export const MARK_MESSAGE_READ_SENT = 'MARK_MESSAGE_READ_SENT';
export const MARK_MESSAGE_READ_SUCCEEDED = 'MARK_MESSAGE_READ_SUCCEEDED';
export const MARK_MESSAGE_READ_FAILED = 'MARK_MESSAGE_READ_FAILED';
export const RECEIVED_NEW_MESSAGE = 'RECEIVED_NEW_MESSAGE'; // LATER
export const MESSAGE_READ_BY_SOMEONE = 'MESSAGE_READ_BY_SOMEONE'; // LATER

export function fetchSent() {
  return { type: FETCH_MESSAGES_SENT };
}

export function fetchSucceeded(data) {
  return {
    type: FETCH_MESSAGES_SUCCEEDED,
    payload: data,
  };
}

export function fetchFailed(error) {
  return { type: FETCH_MESSAGES_FAILED };
}

export function fetch(conversationId) {
  return (dispatch) => {
    dispatch(fetchSent());
    return MessageApiUtils.fetch(conversationId).then(
      (data) => dispatch(fetchSucceeded(data)),
      (error) => dispatch(fetchFailed(error)),
    );
  };
}

export function loadMoreSent() {
  return { type: LOAD_MORE_MESSAGES_SENT };
}

export function loadMoreSucceeded(data) {
  return {
    type: LOAD_MORE_MESSAGES_SUCCEEDED,
    payload: data,
  };
}

export function loadMoreFailed(error) {
  return { type: LOAD_MORE_MESSAGES_FAILED };
}

export function loadMore(conversationId, lastMessageId, lastMessageSent) {
  return (dispatch) => {
    dispatch(loadMoreSent());
    return MessageApiUtils.loadMore(
      conversationId,
      lastMessageId,
      lastMessageSent,
    ).then(
      (data) => dispatch(loadMoreSucceeded(data)),
      (error) => dispatch(loadMoreFailed(error)),
    );
  };
}

export function sendMessageSent(conversationObj, messageObj) {
  return {
    type: SEND_MESSAGE_SENT,
    payload: {
      conversationObj,
      messageObj,
    },
  };
}

export function sendMessageSucceeded(data) {
  return {
    type: SEND_MESSAGE_SUCCEEDED,
    payload: data,
  };
}

export function sendMessageFailed(error, newData) {
  return { type: SEND_MESSAGE_FAILED, payload: newData };
}

export function sendMessage(conversationObj, messageObj) {
  return (dispatch) => {
    dispatch(sendMessageSent(conversationObj, messageObj));
    return MessageApiUtils.sendMessage(messageObj.toPlainObject()).then(
      (data) => dispatch(sendMessageSucceeded(data)),
      (error) => {
        // Create cloned objects to avoid mutating Redux state
        const clonedMessageObj = messageObj.clone();
        const clonedConversationObj = conversationObj.clone();
        clonedMessageObj.sendFailed();
        clonedConversationObj.updateLastMessage(clonedMessageObj);
        const newData = {
          conversationObj: clonedConversationObj,
          messageObj: clonedMessageObj,
        };
        dispatch(sendMessageFailed(error, newData));
      },
    );
  };
}

export function markReadSent(conversationId, messageId, userId) {
  return {
    type: MARK_MESSAGE_READ_SENT,
    payload: {
      conversationId,
      messageId,
      userId,
    },
  };
}

export function markReadSucceeded(data) {
  return {
    type: MARK_MESSAGE_READ_SUCCEEDED,
    payload: data,
  };
}

export function markReadFailed(error) {
  return { type: MARK_MESSAGE_READ_FAILED };
}

export function markRead(conversationId, messageId, userId) {
  return (dispatch) => {
    dispatch(markReadSent(conversationId, messageId, userId));
    return MessageApiUtils.markRead(conversationId, messageId).then(
      (data) => dispatch(markReadSucceeded(data)),
      (error) => dispatch(markReadFailed(error)),
    );
  };
}

export function receivedNewMessage(data) {
  return {
    type: RECEIVED_NEW_MESSAGE,
    payload: data,
  };
}

export function readBySomeone(data) {
  return {
    type: MESSAGE_READ_BY_SOMEONE,
    payload: data,
  };
}
